import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class DocumentApiService {
  private baseUrl = environment.baseUrl + 'document';

  constructor(private http: HttpClient) {}

  count() {
    return this.http.get<{ docCount: number; expCount: number }>(`${this.baseUrl}/count`);
  }

  findAllExpiring() {
    return this.http.get<any[]>(`${this.baseUrl}/expiring`);
  }

  findAllForUser(userId: number | string) {
    return this.http.get<any>(`${this.baseUrl}/user/${userId}`);
  }

  findAllForTruck(truckId: number | string) {
    return this.http.get<any[]>(`${this.baseUrl}/truck/${truckId}`);
  }

  findOne(documentId: number | string) {
    return this.http.get<any>(`${this.baseUrl}/${documentId}`);
  }

  attach(dto: any) {
    return this.http.post<any>(this.baseUrl, dto);
  }

  attachToOrder(dto: any) {
    return this.http.post<any>(`${this.baseUrl}/order`, dto);
  }

  attachToTruck(truckId: number | string, dto: any) {
    return this.http.post<any>(`${this.baseUrl}/truck/${truckId}`, dto);
  }

  update(documentId: number | string, dto: any) {
    return this.http.patch<any>(`${this.baseUrl}/${documentId}`, dto);
  }

  markRead(documentId: number | string) {
    return this.http.patch<any>(`${this.baseUrl}/update/status/${documentId}`, {});
  }

  delete(documentId: number | string) {
    return this.http.delete<any>(`${this.baseUrl}/delete/${documentId}`);
  }

  getDownloadUrl(fileKey: string) {
    const encodedKey = encodeURIComponent(fileKey);
    return this.http.get<{ downloadUrl: string }>(
      `${this.baseUrl}/download?fileKey=${encodedKey}`,
    );
  }
}
